<template>
  <div class="aaa">
    <div class="navTop">
      <div>
        <logo :height="50" color="#ffdead" />
        <div>
          <span @click="$go('/search')">
            <img :src="require('@/assets/navTop/third/2.png')">
            搜索
          </span>
          <span @click="$go('/Secretary')">
            <img :src="require('@/assets/navTop/third/3.png')">
            <!--第一书记-->
            {{ this.$store.getters.info.fristName }}
          </span>
          <span @click="$go(`/GetPbDem`)">
            <img :src="require('@/assets/navTop/third/4.png')">
            支部风采
          </span>
          <span @click="cliDyLogin">
            <img :src="require('@/assets/navTop/third/5.png')">
            党员登录
          </span>
          <span @click="$go('/personal')">
            <img :src="require('@/assets/navTop/third/6.png')">
            个人中心
          </span>
        </div>
      </div>
    </div>
    <div class="navTop2">
      <div>
        <div v-for="(i,index) in firstList" :key="index" class="click" @click="go(i.href)">{{ i.name }}</div>
        <div v-if="moreList.length" class="click" @click="clickMoreText">{{ moreText }}</div>
      </div>
      <div v-show="moreText==='更多 -'">
        <div v-for="(i,index) in moreList" :key="index" class="click" @click="go(i.href)">{{ i.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstList: [
      ],
      moreList: [
      ],
      moreText: '更多 +'
    }
  },

  mounted() {

  },
  created() {
    this.$store.dispatch('app/MenuGetMenus').then(res => {
      if (res.code === 0) {
        this.firstList = res.data.slice(0, 14)
        this.moreList = res.data.slice(14)
      }
    })
  },

  methods: {
    clickMoreText() {
      if (this.moreText === '更多 +') {
        this.moreText = '更多 -'
      } else {
        this.moreText = '更多 +'
      }
    },
    go(href) {
      if (window.location.href === href) return
      this.$go(href)
    },
    cliDyLogin() {
      this.$store.dispatch('app/SitePmLoginUrl').then(res => {
        if (res.code === 0) {
          window.location.href = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.aaa{
  position: relative;
      &::after{
        background: var(--theme);
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        opacity: .8;
        content: "";
        display: block;
        z-index: -1;
      }
}
  .navTop{
    &>div{
      width: 1300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;

      &>img{
        width: 202px;
        height: 44px;

      }
       &>div{
         display: flex;
          align-items: center;
         span{
           cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ECD597;
            &::after{
              content: '';
              height: 16px;
              background:#ECD597;
              width: 1px;
              margin:0 17px;
            }
            &:nth-last-child(1):after{
              width: unset;
            }
            img{
              width: 20px;
              height: 20px;
              margin-right: 3px;
            }
         }
       }
    }
  }
  .navTop2{
    &>div:first-child{
      width: 1300px;
      height: 48px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      &>div{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ECD597;
        margin-right: 32px;
      }
      &>div:last-child{
        margin-right: unset;
      }
    }
    &>div:last-child{
      width: 1300px;
      height: 48px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      &>div{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ECD597;
        margin-right: 32px;
      }
    }
  }
</style>
